import { useEffect } from "react"

function setViewportVar() {
  const height = (window.visualViewport?.height ?? window.innerHeight) * 0.01
  document.documentElement.style.setProperty("--app-vh", `${height}px`)
}

export default function useMobileViewport() {
  useEffect(() => {
    // Add platform classes for CSS targeting
    const docEl = document.documentElement
    const ua = navigator.userAgent.toLowerCase()
    if (/android/.test(ua)) docEl.classList.add("android")
    if (/iphone|ipad|ipod/.test(ua)) docEl.classList.add("ios")

    // Initialize CSS var and unlock any leftover scroll locks
    setViewportVar()
    const unlock = () => {
      document.documentElement.style.overflow = ""
      document.body.style.overflow = ""
      document.body.style.position = ""
      document.body.style.touchAction = ""
    }
    unlock()

    const onResize = () => setViewportVar()
    const onOrientation = () => setViewportVar()
    const onPageshow = (e: PageTransitionEvent) => {
      if (e.persisted) setViewportVar()
    }

    window.addEventListener("resize", onResize)
    window.addEventListener("orientationchange", onOrientation)
    window.addEventListener("pageshow", onPageshow)
    window.visualViewport?.addEventListener("resize", onResize)

    // Minor next-tick to ensure layout after route swaps
    const raf = requestAnimationFrame(setViewportVar)

    return () => {
      cancelAnimationFrame(raf)
      window.removeEventListener("resize", onResize)
      window.removeEventListener("orientationchange", onOrientation)
      window.removeEventListener("pageshow", onPageshow)
      window.visualViewport?.removeEventListener("resize", onResize)
    }
  }, [])
}
